import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../../data/siteData";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white/90 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img
            src="/assets/celestraone-logo.png"
            alt="CelestraOne Ventures Pvt. Ltd."
            className="h-12 md:h-14 w-auto object-contain"
            data-testid="nav-logo"
          />
          <div className="hidden sm:block leading-tight">
            <p className="font-display text-lg md:text-xl font-bold tracking-tight text-black" data-testid="nav-brand-name">CelestraOne Ventures</p>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="nav-desktop">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold tracking-wide transition-colors duration-200 ${
                  isActive ? "text-[#D40000]" : "text-gray-700 hover:text-black"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-call-button"
            className="inline-flex items-center gap-2 whitespace-nowrap border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-800 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#25D366] hover:text-[#25D366]"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            {CONTACT.phoneDisplay}
          </a>
          <Link
            to="/contact"
            data-testid="nav-quote-button"
            className="inline-flex items-center gap-2 bg-[#D40000] px-5 py-2 text-sm font-bold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-red-900"
          >
            Request a Quote
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-gray-800"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-gray-200 bg-white px-4 py-4 space-y-1" data-testid="nav-mobile">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`block px-3 py-3 text-base font-semibold ${
                location.pathname === l.to ? "text-[#D40000]" : "text-gray-800"
              }`}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-mobile-call-button"
            className="mt-2 flex items-center justify-center gap-2 bg-[#D40000] px-4 py-3 text-sm font-bold text-white"
          >
            <Phone size={15} /> Call {CONTACT.phoneDisplay}
          </a>
        </nav>
      )}
    </header>
  );
};
